import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ClearSelectedButton(props) {
  const { disableClearSelected, onClickClearSelected } = props;

  return (
    <ButtonWithIcon
      id="bar-chart-dialog-header-sorting-clear-selected"
      data-e2e="bar-chart-dialog-header-clear-selected"
      className="bar-chart-checkboxes-dialog-header-controls-clear-selected u-els-margin-left"
      type="link"
      sprite="Trash"
      iconRight
      disabled={disableClearSelected}
      onClick={onClickClearSelected}>
      Clear selected
    </ButtonWithIcon>
  );
}

ClearSelectedButton.propTypes = {
  disableClearSelected: PropTypes.bool.isRequired,
  onClickClearSelected: PropTypes.func.isRequired,
};

export default ClearSelectedButton;
